import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutType } from '../../models/layout-type/layout-type';
import { WidgetHomesResolver } from './widget-homes.resolver';
import { WidgetHomesPage } from './widget-homes/widget-homes.page.component';
import { WidgetRoomsResolver } from './widget-rooms.resolver';
import { WidgetRoomsPage } from './widget-rooms/widget-rooms.page.component';
import {WidgetCOHOPreviewsPage} from "./widget-coho-previews/widget-coho-previews.page";
import {WidgetCOHOPreviewsResolver} from "./widget-coho-previews/widget-coho-previews.resolver";


const routes: Routes = [
    { path: ':organisation/homes', component: WidgetHomesPage, resolve: { homes: WidgetHomesResolver }, data: { layout: LayoutType.EMPTY } },
    { path: ':organisation/rooms', component: WidgetRoomsPage, resolve: { rooms: WidgetRoomsResolver }, data: { layout: LayoutType.EMPTY } },
    { path: 'landing/:locationReference', component: WidgetCOHOPreviewsPage, resolve: { landingArea: WidgetCOHOPreviewsResolver }, data: { layout: LayoutType.EMPTY } },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})
export class WidgetRouting { }
